import React from 'react';
import "./SportOneJoinFamily.scss";

const SportOneJoinFamily = () => {
    return (
        <section className="sport-one-join-family-section">
            <h2>Join the W18 family</h2>
            <div className="join-family-cards">
                <div className="card-left">
                    <h3>Careers at W18</h3>
                    <div className="avatars">
                        <img src="/assets/img/sports/sport-one/images/avatar1.png" alt="Member" />
                        <img src="/assets/img/sports/sport-one/images/avatar2.jpg" alt="Member" />
                        <img src="/assets/img/sports/sport-one/images/avatar3.jfif" alt="Member" />
                        <img src="/assets/img/sports/sport-one/images/avatar4.jpg" alt="Member" />
                    </div>
                    <a href="#" className="learn-more">LEARN MORE</a>
                </div>
                <div className="card-right">
                    <h3><span className="highlight">W18</span> franchise<br />opportunities</h3>
                    <p>Partner with the fastest growing sports & fitness brand</p>
                    <a href="#" className="learn-more">LEARN MORE</a>
                </div>
            </div>
        </section>
    );
};

export default SportOneJoinFamily;
